import { api, ApiRequestConfig } from './api';
import { SponsoredBrandRequest } from '../types/sponsored-brands';

export const getSponsoredBrands = (props: SponsoredBrandRequest, config: ApiRequestConfig) =>
  api.get('sponsored-brands', { ...props }, config);
